import type { LogLevelDesc } from 'loglevel';
import { logger } from '@springtree/eva-sdk-core-logger';
import { EVA_LOGGER_LEVEL } from '@/core/constants/env';
import Storage from '@/core/services/cookie-storage';
import {
  addRequestInterceptor,
  addResponseInterceptor,
} from '@/core/services/eva/call-eva-service';

const requestInterceptor = async (request: Request) => {
  const [organizationUnitId, appToken, authenticationToken] = await Promise.all(
    [
      Storage.get('evaOrganizationUnitId'),
      Storage.get('evaAppToken'),
      Storage.get('evaAuthenticationToken'),
    ],
  );

  if (organizationUnitId) {
    // This mirrors the behavior of the SDK (@springtree/eva-sdk-core-service/lib/service.js)
    request.headers.set(
      'EVA-Requested-OrganizationUnitID',
      String(organizationUnitId),
    );
  }

  if (appToken) {
    // This mirrors the behavior of the SDK (@springtree/eva-sdk-core-service/lib/service.js)
    request.headers.set('EVA-App-Token', appToken);
  }

  if (authenticationToken) {
    // This mirrors the behavior of the SDK (@springtree/eva-sdk-core-service/lib/service.js)
    request.headers.set('Authorization', authenticationToken);
  }

  return request;
};

const responseInterceptor = async (
  response: Response,
  _: Request,
  { retry }: { retry: () => Promise<Response> },
) => {
  const newAppToken = response.headers.get('eva-app-token');

  if (newAppToken) {
    await Storage.set('evaAppToken', newAppToken);
  }

  if (response.status === 401) {
    await Storage.remove('orderId');
    await Storage.remove('evaAppToken');
    await Storage.remove('evaAuthenticationToken');

    return retry();
  }

  return response;
};

addRequestInterceptor(requestInterceptor);
addResponseInterceptor(responseInterceptor);

logger.setLevel((EVA_LOGGER_LEVEL as LogLevelDesc) || 'SILENT');
